import React from 'react';
import { Item } from '@/stores/canvasStore';

interface PartnrReferencedItemBorderProps {
  item: Item;
}

export function PartnrReferencedItemBorder({ item: _item }: PartnrReferencedItemBorderProps) {
  return (
    <div
      className="absolute -inset-1 pointer-events-none partnr-referenced-border rounded-xl"
      style={{
        border: '2px solid hsl(var(--partnr))',
      }}
    />
  );
}
